import moment from "moment";
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { OverlayTrigger, Popover } from "react-bootstrap";
import DeliveryGraph from "./deliveryGraph";
import { formatPercent } from "../utils/constants";
import StockAction from "./stockAction";
import { setDeliveryDataReducer } from "../redux/slice/deliveryData";
import { getDeliveryPercentList, getDurationDaysPrice } from "../action/api-services";
import sectorIcon from "../assets/images/sector.svg"
import loaderIcon from "../assets/images/loader.gif"

export default function SectorPanchang({symbol, sector, todayData, symbolData, tag, align, durationDays}) {
const dispatch = useDispatch();
const [loader, setLoader] = useState(false);
const [getBgColor, setBgColor] = useState();   
const [getSectorData, setSectorData] = useState([]);   
const [getSectorPerformance, setSectorPerformance] = useState('');   
const [getCurrentTime, setCurrentTime] = useState();
const NSE_Past_date = useSelector((state) => state.pastDate.value);
const panchang = useSelector((state) => state.panchangUpdate.value);
const userToken = useSelector((state) => state.userToken.value);
const deliveryDataList = useSelector((state) => state.deliveryData.value);
const [currentSort, setCurrentSort] = useState(false);

// const panchang = JSON.parse(localStorage.getItem("panchang")) || {};
useEffect(() =>{
  if(panchang){   
              let pastDate;
              let currentDate;
              let nextDate;
                
              let currentTime = panchang.Nakshatra_time?.split('to')[1];              
              setCurrentTime(currentTime);

              const start = moment(panchang.Nakshatra_time?.split('to')[0], "DD-MM-YYYY HH:mm");
              const end   = moment(panchang.Nakshatra_time?.split('to')[1], "DD-MM-YYYY HH:mm");
  
              if (moment().isBetween(start, end, null, "[]")) {
                    pastDate    = panchang?.CurrentNakshatraSector?.includes(sector);
                    currentDate = panchang?.NextNakshatraSector?.includes(sector);                    
                    nextDate    = panchang?.NextNakshatraSector2?.includes(sector);
              } else {
                    // console.log("nnnnn 222");
                    pastDate    = panchang?.PastNakshatraSector?.includes(sector);
                    currentDate = panchang?.CurrentNakshatraSector?.includes(sector);                    
                    nextDate    = panchang?.NextNakshatraSector?.includes(sector);
              }

        let bgColor = currentDate ? "#d0ffd2" : pastDate ? "#ffd1d1" : nextDate ? "#fff6c8" : "transparent";
        setBgColor(bgColor);
  }

},[panchang])

const togglePopover = (sector) => {
  let getDurationDaysData = [];
  let loaderTime = 4000;

                if(durationDays !== ''){
                    const [fromDate, toDate] = durationDays.split("to").map(item => item.trim());
                    
                    getDurationDaysPrice({'fromDate': fromDate, 'toDate': toDate, 'sector': sector, 'series':'EQ'}, userToken)
                    .then(res => {
                        getDurationDaysData = res.data;
                        loaderTime = 4000;
                    }).catch(console.error);



                }else{
                  loaderTime = 1;
                }                    

                    
                    getDeliveryPercentList('', 'sectors', sector, '', 'EQ', '', userToken)
                    .then(res => {

                        const oldData = Array.isArray(deliveryDataList)
                            ? deliveryDataList
                            : Object.values(deliveryDataList || {});

                        const newData = Array.isArray(res.data.data)
                            ? res.data.data
                            : Object.values(res.data.data || {});

                        // Existing symbols
                        const oldSymbols = new Set(
                            oldData.map(item => item.symbol)
                        );

                        // Only new symbols
                        const uniqueNewData = newData.filter(
                            item => !oldSymbols.has(item.symbol)
                        );

                        dispatch(
                            setDeliveryDataReducer([
                                ...oldData,
                                ...uniqueNewData
                            ])
                        );
                    })
                    .catch(console.error);






  setTimeout(()=>{
        const sectorData = symbolData?.filter((item) => item.group_sector === sector && parseInt(item.active) === 1)
        .map((item) =>{
              const LTP = todayData?.filter((f) => f.TICKER === item.symbol);
              const Duration = getDurationDaysData?.filter((f) => f.symbol === item.symbol);

              // let deliveryData = useSelector((state) => state.deliveryData.value);
              let deliverylist = Object.values(deliveryDataList);
              let delivery = deliverylist?.find((s) => s.symbol === item.symbol);
              let lastChild = delivery?.stock_data?.length - 1;


              const aLTP = Number(LTP?.LTP);

              const aClose1 = Number(delivery?.stock_data?.[0]?.close_price);
              const aClose5 = Number(delivery?.stock_data?.[lastChild]?.close_price);
              const aCurrLTP = !isNaN(aLTP) && aLTP > 0 ? aLTP : aClose1;
              const aPL_per = ((aCurrLTP - aClose5) / aClose5) * 100;

              
              return {
                ...item,
                // ltp:LTP,
                delivery:delivery,
                PL_per:aPL_per,
                ltp:  durationDays !== '' && Duration?.length > 0 ? [{ ...LTP?.[0], CHANGEPER: Duration?.[0]?.CHANGEPER}] : LTP,
                trueAvgVolume: durationDays !== '' && Duration?.length > 0 ? Duration?.[0]?.trueAvgVolume : 0
              }
        }).sort((a, b) => {
              const aVal = a.ltp?.[0]?.CHANGEPER;
              const bVal = b.ltp?.[0]?.CHANGEPER;

              const aNum = aVal !== '#N/A' && aVal != null ? Number(aVal) : -Infinity;
              const bNum = bVal !== '#N/A' && bVal != null ? Number(bVal) : -Infinity;

              return bNum - aNum;
        });
        setSectorData(sectorData);

        // console.log(sectorData);
        let profit = 0;
        let loss = 0;
        let performanceMeta = {};

        sectorData.forEach(stock => {   
          let CHANGEPER = stock.ltp[0]?.CHANGEPER !== '#N/A'? stock.ltp[0]?.CHANGEPER: 0;

            if(CHANGEPER > 0){
              profit +=1;
            }else{
              loss +=1;
            }
        })

        performanceMeta = {
          profit: profit,
          loss: loss,
          total: sectorData.length
        }
        
        setSectorPerformance(performanceMeta);
        setLoader(true);
  }, loaderTime)

}



const dataSortBy = (filterType, sortby) => {
    setCurrentSort(sortby);
    if(filterType === "CHN"){
            getSectorData.sort((a, b) => {
                const aVal = a.ltp?.[0]?.CHANGEPER;
                const bVal = b.ltp?.[0]?.CHANGEPER;

                const aNum = aVal !== '#N/A' && aVal != null && !isNaN(Number(aVal))
                    ? Number(aVal)
                    : -Infinity;

                const bNum = bVal !== '#N/A' && bVal != null && !isNaN(Number(bVal))
                    ? Number(bVal)
                    : -Infinity;

                return currentSort
                    ? aNum - bNum  // Low → High
                    : bNum - aNum;   // High → Low
            });
          
    }
    else if(filterType === "CHN5"){          
            getSectorData.sort((a, b) => {
                const aPL = a.PL_per;
                const bPL = b.PL_per;

                return currentSort
                    ? aPL - bPL   // Low → High
                    : bPL - aPL;   // High → Low
            });

    }

     else if(filterType === "VOLUME"){          
            getSectorData.sort((a, b) => {
                const aVal = a.ltp?.[0]?.VOLUME;
                const bVal = b.ltp?.[0]?.VOLUME;

                const aNum = aVal !== '#N/A' && aVal != null && !isNaN(Number(aVal))
                    ? Number(aVal)
                    : -Infinity;

                const bNum = bVal !== '#N/A' && bVal != null && !isNaN(Number(bVal))
                    ? Number(bVal)
                    : -Infinity;

                return currentSort
                    ? aNum - bNum  // Low → High
                    : bNum - aNum;   // High → Low
            });

    }
};



const popover = (
    
    <Popover id={`popoverSector`} className="strengthTooltip">
        <Popover.Header as="h4"><span style={{ marginRight:'10px'}}>{sector}</span> [<strong style={{color:'#69cb19'}}>{getSectorPerformance?.profit}</strong>/<strong style={{color:'#f00'}}>{getSectorPerformance?.loss}</strong> | <strong>{getSectorPerformance?.total}</strong>]</Popover.Header>
        
        <Popover.Body>
                <div className="pop_sector_body">
                <table className="sector_p_pop">
                  <thead>
                    <tr><th>Symbol</th><th></th><th></th><th>Chn<button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('CHN', !currentSort)}}></button></th><th>5D Chn<button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('CHN5', !currentSort)}}></button></th><th>Volume<button className="dataSort" onClick={(e)=> {e.preventDefault(); dataSortBy('VOLUME', !currentSort)}}></button></th></tr>
                  </thead>
                  <tbody>   
                    
                    {getSectorData?.length > 0?                
                    getSectorData?.map((item, index) => {
                      const changePer = item?.ltp?.[0]?.CHANGEPER;
                      let CHANGEPER = changePer && changePer !== '#N/A' ? changePer : 0;
                      // let CHANGEPER = item.ltp[0]?.CHANGEPER!== '#N/A'? item.ltp[0]?.CHANGEPER : 0;

                      
                      return(
                          <tr key={index} style={{background: item.symbol === symbol? "#ffeb3b": CHANGEPER >= 5 && item.ltp[0]?.VOLUME > 300000 && Number(item.trueAvgVolume) === 1? "#f3fff9":""}} className={`tr_${item.id}`}>
                              <td className={`symbolName  ${item.in_watchlist ==='1'? 'inwatchlist':''}`}>
                                {item.symbol}                       
                                  {item.hotStar === "1" ? (
                                    <span className="hotStar"></span>
                                  ) : null}

                                  {item.delivery?.current_star === "1" ? (
                                    <span className="currStar"></span>
                                    ) : null}
                              </td>
                              
                              
                               <td style={{Width:'10px'}}>
                                  <StockAction
                                    symbol={item.symbol}
                                    delivery={false}
                                    currentPrice={item.ltp[0]?.LTP }
                                    deliveryPer={item.delivery_per}
                                    hotStar={item.hotStar}
                                    myFev={item.myFev}
                                    // eventName={'Sector Performance'}
                                    // slPrice={item.close_price * 0.96}
                                    // gttPrice={item.close_price * 1.04}
                                    // rowId=""
                                  />
                                
                               </td>

                              <td style={{textAlign:'left', 'width':'40px'}} className="inside_popover"><DeliveryGraph symbol={item.symbol} todayLTP={item.ltp[0]}  
                              // date={moment(moment(getCurrentTime, "DD-MM-YYYY HH:mm")).format("YYYY-MM-DD")} 
                              date={moment(moment(getCurrentTime, "DD-MM-YYYY HH:mm")).format("YYYY-MM-DD") > moment(NSE_Past_date[0]?.max_date).format('YYYY-MM-DD')? 
                                moment(NSE_Past_date[0]?.max_date).format('YYYY-MM-DD') : moment(moment(getCurrentTime, "DD-MM-YYYY HH:mm")).format("YYYY-MM-DD") } 
                               />
                               </td>

                              <td style={{'width':'50px'}}>{formatPercent(CHANGEPER)}</td>
                              <td style={{'width':'68px'}}>{formatPercent(item.PL_per)}</td>
                              <td style={{'width':'72px'}}>{parseInt(item.ltp[0]?.VOLUME)?.toLocaleString('en-IN')}</td>
                          </tr>
                      )
                    })
                    
                    
                    :<tr><td colSpan={5}>
                        <div style={{minHeight:'250px', height: '100%', display:'flex', justifyContent: "center", alignItems: "center"}}> <img src={loaderIcon} alt="" style={{width:'40%'}} /></div>
                      </td></tr>}
                  </tbody>
                </table>
                </div>
        </Popover.Body>
        
    </Popover>
    
);


  const Tag = tag === "td" ? "td" : tag;

  return (
    <Tag
    style={
      tag === "li"
        ? { textAlign: "left" }
        : {
            textAlign: "left",
            lineHeight: "1",
            background: getBgColor
          }
    }
  >
      <OverlayTrigger
            key = {`sid_${sector}}`}
            placement = {align}
            trigger = "click"
            container={document.body} 
            rootClose = {true}
            overlay={popover}
      >
      {tag === "td" ? 
      <span style={{'width': '100%', 'display':'block', 'cursor':'pointer'}}
          onClick={(e) => {
              e.preventDefault();
              togglePopover(sector);
          }}
      > {sector}</span>
      
      :
          <a href="#"  onClick={(e) => {
              e.preventDefault();
              togglePopover(sector);
          }}><img src={sectorIcon} style={{width:'100%', maxHeight: '20px'}} /></a>
        
      }
      </OverlayTrigger>
    
    </Tag>
  );
    
}
